// stores/useFeeTypesStore.ts
import { create } from 'zustand';
import apiClient from '../services/axiosInterceptor';

export interface FeeType {
  id: number;
  fee_name: string;
  status: 'active' | 'inactive';
  optional: 0 | 1;
}

interface FeeTypesState {
  feeTypes: FeeType[];
  loading: boolean;
  error: string | null;
  fetchFeeTypes: (
    schoolId: string,
    params?: { status?: 'active' | 'inactive'; optional?: 0 | 1 }
  ) => Promise<void>;
}

export const useFeeTypesStore = create<FeeTypesState>((set) => ({
  feeTypes: [],
  loading: false,
  error: null,

  fetchFeeTypes: async (schoolId, params = {}) => {
    if (!schoolId) {
      set({ error: 'School ID is required', loading: false });
      return;
    }

    set({ loading: true, error: null });

    try {
      const response = await apiClient.get('api/fee-types', {
        params: { school_id: schoolId, ...params },
      });
      const { data } = response.data; // expects { status, message, data: [...] }

      set({
        feeTypes: Array.isArray(data) ? data : [],
        loading: false,
      });
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        'Failed to load fee types';

      set({
        loading: false,
        error: errorMessage,
      });
    }
  },
}));